import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { Menu as MenuIcon } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useEffect } from 'react';

export default function DropdownMenu(props) {
  const { defaultValue, options, onChange } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(defaultValue || null);
  const [rows, setRows] = useState(options || []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (e, value) => {
    onChange(value);
    setValue(value);
  };

  useEffect(() => {
    setRows(options);
  }, [options]);

  return (
    <div>
      <IconButton size="small" aria-label="menu" onClick={handleClick} sx={{ m: 0, p: 0, color: (theme) => `1px solid ${theme.palette.divider}` }}>
        <MoreVertIcon />
      </IconButton>
      <Menu id="dropdown-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {/* 
        <MenuItem onClick={onChange || handleChange}>Last 28 Days</MenuItem>
        <MenuItem onClick={onChange || handleChange}>Last Month</MenuItem>
        <MenuItem onClick={onChange || handleChange}>Last Year</MenuItem> 
        */}
        {rows.map((option) => (
          <MenuItem key={option} selected={option === value} onClick={(e) => handleChange(e, option)}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
